import { Heart, Clock4, Info } from "lucide-react";

export default function PricingBanner() {
  return (
    <section
      id="pricing"
      data-testid="pricing-banner"
      className="bg-[#D97706] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14 sm:py-16">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-sm uppercase tracking-[0.18em] font-semibold text-white/80">
              Simple, honest pricing
            </p>
            <h2 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight">
              <span className="text-white/60 line-through decoration-white/70 decoration-[3px] mr-3">$2</span>
              <span>$1 AUD per minute.</span>
            </h2>
            <p className="mt-3 text-xl sm:text-2xl font-medium text-white/95">
              That's it. No call-out fees. No hidden costs.
            </p>
            <p className="mt-3 inline-flex items-center gap-2 rounded-full bg-white/15 border border-white/30 px-4 py-1.5 text-sm font-semibold uppercase tracking-wider">
              <span className="h-2 w-2 rounded-full bg-white animate-pulse"></span>
              Now half price — was $2/min
            </p>
            <p className="mt-4 text-sm text-white/90 max-w-md">
              Still <span className="font-semibold text-white">a fraction of what most IT firms charge</span> — where you&apos;re often looking at $100+ per hour with call-out fees on top.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            <div
              data-testid="pricing-card-standard"
              className="bg-white/10 backdrop-blur-sm border border-white/25 rounded-2xl p-6"
            >
              <Clock4 className="w-8 h-8 mb-3" strokeWidth={2} />
              <div className="text-sm uppercase tracking-wide font-semibold text-white/80">
                Standard rate
              </div>
              <div className="mt-1 flex items-baseline gap-2 font-[Outfit]">
                <span className="text-xl font-semibold text-white/60 line-through decoration-white/70 decoration-[2.5px]">$2</span>
                <span className="text-3xl font-bold">$1 / minute</span>
              </div>
              <p className="mt-2 text-sm text-white/90">
                Pay only for the time we work together. Quick fixes stay cheap.
              </p>
            </div>

            <div
              data-testid="pricing-card-seniors"
              className="bg-white text-slate-900 rounded-2xl p-6 shadow-lg"
            >
              <Heart className="w-8 h-8 mb-3 text-[#D97706]" strokeWidth={2} />
              <div className="text-sm uppercase tracking-wide font-semibold text-[#D97706]">
                Eligible seniors
              </div>
              <div className="mt-1 text-3xl font-bold font-[Outfit]">
                Completely free
              </div>
              <p className="mt-2 text-sm text-slate-700">
                Our way of giving back to the community. Just ask when you call.
              </p>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div
          data-testid="pricing-disclaimer"
          className="mt-10 flex items-start gap-3 rounded-xl bg-white/10 border border-white/25 px-5 py-4 text-sm text-white/95"
        >
          <Info className="w-5 h-5 shrink-0 mt-0.5" strokeWidth={2.2} />
          <p>
            <span className="font-semibold">Home &amp; personal use only.</span>{" "}
            The $1/minute rate and free seniors offer apply to residential
            enquiries. <span className="font-semibold">Business tech support is charged at $2/minute</span>
            {" "}— still well under the standard commercial IT rate.
          </p>
        </div>
      </div>
    </section>
  );
}
